const ProgressBar = ({ value, color, className }) => {
  const computedValue = Math.min(Math.max(value, 0), 100);
  const computedColor = color || (computedValue < 25 ? 'red' : computedValue < 50 ? 'orange' : computedValue < 75 ? 'yellow' : 'green');
  return (
    <div className={`comp-progress-bar ${className}`}>
      <div className={`inner color-${computedColor}`} style={{ width: `${computedValue}%` }} data-title={`${computedValue}%`} />
    </div>
  );
};

export default ProgressBar;
